import React, { useState } from "react";
import {
  Body,
  Btn,
  CustomLink,
  ErrorMessage,
  Header,
  InputField,
} from "@client/ui";
import { Divider } from "@mui/material";
import { ColorEnum } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { HEIGHTS } from "../../utils/constants";

const DriverSignup = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (field: string) => (value: string) => {
    setFormData({ ...formData, [field]: value });
    setError(""); // Clear error when user makes changes
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.phoneNumber ||
      !formData.password
    ) {
      setError("Please fill all required fields");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    console.log("Form submitted:", formData);
    // Add logic to send data to the server
  };

  return (
    <div
      className="body-width"
      style={{
        height: `calc(100vh - ${HEIGHTS.footer}px - ${HEIGHTS.navBar}px - 90px)`,
        margin: "auto",
        marginTop: "60px",
        maxWidth: 500,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <Header text={"Driver Signup"} />
      </div>

      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Body text={"Sign up to become a driver"} />
          <Divider style={{ maxWidth: "40%" }} />
        </div>

        <InputField
          label="Full Name"
          value={formData.fullName}
          type="text"
          required={true}
          onChange={handleChange("fullName")}
          error={error !== ""}
        />

        <InputField
          label="Email"
          value={formData.email}
          type="email"
          required={true}
          onChange={handleChange("email")}
          error={error !== ""}
        />

        <InputField
          label="Phone Number"
          value={formData.phoneNumber}
          type="tel"
          required={true}
          onChange={handleChange("phoneNumber")}
          error={error !== ""}
        />

        <InputField
          label="Password"
          value={formData.password}
          type="password"
          required={true}
          onChange={handleChange("password")}
          error={error !== ""}
        />

        <InputField
          label="Confirm Password"
          value={formData.confirmPassword}
          type="password"
          required={true}
          onChange={handleChange("confirmPassword")}
          error={error !== ""}
        />

        <div style={{ marginTop: "20px" }}>
          <Btn
            text="Sign Up"
            onClick={handleSubmit}
            style={{ width: "100%" }}
          />
        </div>

        <div
          style={{
            display: "flex",
            marginTop: "15px",
            gap: "5px",
            justifyContent: "center",
          }}
        >
          <span>Already have an account? </span>
          <CustomLink to="/login" text="Login" color={ColorEnum.Blue} />
        </div>

        {error && <ErrorMessage text={error} />}
      </form>
    </div>
  );
};

export default DriverSignup;
